<div class="toggle-container">
  <div
    class="d-flex flex-center-center toggle-content text-truncate no-select pdl-8px"
    data-cy="tender-more-filters"
    (click)="toggleFilters()"
  >
    {{ (showFilters ? 'tenders.board.less-filters' : 'tenders.board.more-filters') | translate }}
  </div>
</div>
